import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = ["#1e40af", "#22c55e", "#f59e0b", "#3b82f6", "#ef4444", "#94a3b8"];

export default function DonutChart({ items = [], total = 0 }) {
  const totalDowntime = items.reduce((s, i) => s + i.downtime_min, 0) || 1;
  const withPct = items.map((i, idx) => ({
    ...i,
    color: COLORS[idx % COLORS.length],
    pct: (i.downtime_min / totalDowntime) * 100,
  }));

  return (
    <div className="flex items-center gap-4 w-full h-full">
      <div className="relative w-[160px] h-[160px] flex-shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={withPct}
              dataKey="downtime_min"
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={78}
              paddingAngle={2}
              stroke="none"
              isAnimationActive={false}
            >
              {withPct.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(v, n) => [`${Math.round(v)} min`, n]} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center pointer-events-none">
          <div className="text-xl font-black text-slate-900">{Math.round(totalDowntime).toLocaleString()}</div>
          <div className="text-[9px] uppercase tracking-widest text-slate-500 mt-0.5">Total Downtime<br/>(Minutes)</div>
        </div>
      </div>

      <div className="flex-1 space-y-1.5 text-xs min-w-0">
        {withPct.map((i) => (
          <div key={i.mode || i.color} className="flex items-center gap-2 min-w-0">
            <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: i.color }} />
            <div className="text-slate-700 font-semibold truncate flex-1" title={i.mode}>{i.mode}</div>
            <div className="text-slate-500 tabular-nums whitespace-nowrap">
              {i.pct.toFixed(1)}% ({Math.round(i.downtime_min)})
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
